export enum SemanticSearchResponseTypeEnum {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO'
}
